export function uniquePermutationsForMaskedWord(word: string, mask: ("G" | "R" | "empty")[]): number {
  if (word.length !== 9 || mask.length !== 9) {
    throw new Error("Word and mask must be length 9.");
  }


  // Count original letter frequencies
  const originalFreq = new Map<string, number>();
  for (const char of word) {
    originalFreq.set(char, (originalFreq.get(char) || 0) + 1);
  }

  // CASE 1: All positions are empty (start of game)
  if (mask.every(m => m === "empty")) {
    
    const factorial = (n: number): number => {
      if (n <= 1) return 1;
      let res = 1;
      for (let i = 2; i <= n; i++) res *= i;
      return res;
    };

    const total = factorial(9);
    let divisor = 1;
    for (const count of Array.from(originalFreq.values())) {
      divisor *= factorial(count);
    }

    const result = total / divisor;
    return result;
  }

  // CASE 2: Greens + Reds (after submission)
  
  // Count greens and remove those letters from pool
  const usedInGreens = new Map<string, number>();
  for (let i = 0; i < 9; i++) {
    if (mask[i] === "G") {
      const letter = word[i];
      usedInGreens.set(letter, (usedInGreens.get(letter) || 0) + 1);
    }
  }

  // Calculate remaining letters (all non-green letters)
  const remainingLetters: string[] = [];
  for (const [letter, originalCount] of Array.from(originalFreq)) {
    const usedCount = usedInGreens.get(letter) || 0;
    const remainingCount = originalCount - usedCount;
    for (let i = 0; i < remainingCount; i++) {
      remainingLetters.push(letter);
    }
  }

  // Number of positions to arrange = number of reds
  const redPositions = mask.filter(m => m === "R").length;

  const factorial = (n: number): number => {
    if (n <= 1) return 1;
    let res = 1;
    for (let i = 2; i <= n; i++) res *= i;
    return res;
  };

  // Count frequency of remaining letters
  const remainingFreq = new Map<string, number>();
  for (const char of remainingLetters) {
    remainingFreq.set(char, (remainingFreq.get(char) || 0) + 1);
  }

  const total = factorial(redPositions);
  let divisor = 1;
  for (const count of Array.from(remainingFreq.values())) {
    divisor *= factorial(count);
  }

  const result = total / divisor;
  return result;
}